import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

/**
 * If all user's cars are owned and the user says they make loan or lease payments, ask the user to select the financed cars.
 */
export const SelectFinancedCarsStep: Step = {
  id: 'selectfinancedcars',
  pathname: '/selectfinancedcars',
  canShow: (appData) => {
    return !!appData.confirmOwnership?.shouldSelectFinancedCars;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Cars,
};
